import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import Hotjar from "@hotjar/browser";
import { SMUser } from "..";

const HOTJAR_VERSION = 6;
const TIMEOUT = 2 * 1000;

@Module({ name: "MHotjar", namespaced: true })
export default class MHotjar extends VuexModule {
  @Mutation
  async initHotjar(siteId: number) {
    // if (process.env.NODE_ENV !== "production") return;

    if (!siteId) return;

    setTimeout(() => {
      Hotjar.init(siteId, HOTJAR_VERSION);

      if (!SMUser.currentId) return;

      Hotjar.identify(SMUser.currentId.toString(), {});
    }, TIMEOUT);
  }
}
